'use client'

import { useQuery } from '@tanstack/react-query'

import { validatePostalCodeField } from 'modules/customer'
import { QueryKey } from 'shared/api'

import { getCitiesByPostalCodeService } from '../api'

export default function useQueryDeliveryCities(
  postalCode: string
) {
  return useQuery<string[]>({
    queryKey: [QueryKey.deliveryCitiesForPostalCode, postalCode],
    queryFn: async ({ queryKey }) => {
      const queryPostalCode = queryKey[1] as string

      const validatePostalCode = validatePostalCodeField({
        postalCode: queryPostalCode
      })

      const isValid = await new Promise<boolean>(resolve => {
        void validatePostalCode('postalCode', ({ valid }) => resolve(valid))
      })

      if (!isValid) {
        return Promise.resolve([])
      }

      return getCitiesByPostalCodeService(queryPostalCode)
    },
    enabled: !!postalCode,
    staleTime: 1000 * 5
  })
}
